import { RootState } from "@/store/store";
import { liveUsageResourceTypeFailedStatusesByResourceTypeSelector } from "@/store/live-usage-mgmt/selectors/resource-info-status/liveUsageResourceTypeFailedStatusesByResourceTypeSelector";
import { liveUsageMgmtAccountIdsSelector } from "@/store/live-usage-mgmt/selectors/store-selectors/liveUsageMgmtAccountIdsSelector";
import { ResourceType } from "@/services/cloudchipr.api";

export const liveUsageResourceTypeFailedForAllAccountsSelector = (
  state: RootState,
  resourceType: ResourceType,
) => {
  const statuses =
    liveUsageResourceTypeFailedStatusesByResourceTypeSelector(state);
  const accountIds = liveUsageMgmtAccountIdsSelector(state);

  return statuses?.[resourceType]?.length === accountIds?.length;
};
